export const documentsAllowedExtensions = [
  'jpg',
  'pdf',
  'doc',
  'docx',
  'jpeg',
  'png',
  'raw',
  'tiff',
  'bmp',
];